import { InitializerProviderService } from '../services/initializer-provider.service';

export function InitializerProviderFactory(provider: InitializerProviderService) {
    return () => provider.load();
}